export const contact = {
  title: "お問い合わせ",
} as const;
